import { render, staticRenderFns } from "./EditViaje.vue?vue&type=template&id=78f9ed71"
import script from "./EditViaje.vue?vue&type=script&lang=js"
export * from "./EditViaje.vue?vue&type=script&lang=js"
import style0 from "./EditViaje.vue?vue&type=style&index=0&id=78f9ed71&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports